/** Parse chat timestamps from backend rows.
 *
 * Backend chat timestamps are ISO strings without a timezone suffix, but are
 * emitted from UTC containers in production. Treat bare ISO timestamps as UTC
 * so ordering and display match the user's local browser time.
 */
export function parseChatTimestampMs(value: number | string | null | undefined): number {
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return NaN;
    return value < 1_000_000_000_000 ? value * 1000 : value;
  }

  if (typeof value !== 'string') return NaN;
  const raw = value.trim();
  if (!raw) return NaN;

  if (/^\d+(\.\d+)?$/.test(raw)) {
    const numeric = Number(raw);
    return numeric < 1_000_000_000_000 ? numeric * 1000 : numeric;
  }

  const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(raw);
  const normalized = hasTimezone ? raw : `${raw}Z`;
  const parsed = Date.parse(normalized);
  if (Number.isFinite(parsed)) return parsed;

  return Date.parse(raw);
}

export function formatChatTime(value: number | string | null | undefined): string {
  const parsed = parseChatTimestampMs(value);
  if (!Number.isFinite(parsed)) return value == null ? '' : String(value);
  return new Date(parsed).toLocaleTimeString();
}
